import { render, staticRenderFns } from "./NotAuthorizedLayout.vue?vue&type=template&id=28896427&scoped=true&"
import script from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"
export * from "./NotAuthorizedLayout.vue?vue&type=script&lang=js&"
import style0 from "./NotAuthorizedLayout.vue?vue&type=style&index=0&id=28896427&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28896427",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
installComponents(component, {VApp})
